import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ProgressIndicator, Pivot, PivotItem } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../../../../../../../app/Hooks"
import { getPage } from "../../../../../../../../../app/Pages"
import { setPage } from "../../../../../../../../layouts/Master/MasterLayoutSlice"
import { setTitle } from "../../../../../../../../common/NavHeader/NavHeaderSlice"
import { useSetInterval, useConst } from '@fluentui/react-hooks';
import { Table } from "../../../../../../../../common/Table/Table"
import { ApiMessage, getHeaders } from "../../../../../../../../../app/Api"
import { useId, useBoolean } from '@fluentui/react-hooks';

import * as google_protobuf_wrappers_pb from 'google-protobuf/google/protobuf/wrappers_pb'
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { getMainTheme } from "../../../../../../../../../app/Themes"
import { SearchField } from "../../../../../../../../common/SearchField/SearchField"
import { formatDate, printComponent, normalizeKey } from "../../../../../../../../../app/Helpers"
import { TableState } from "../../../../../../../../common/Table/TableSate"
import { Message } from "../../../../../../../../common/Message/Message"
import { ShareBox } from "../../../../../../../../common/ShareBox/ShareBox"
import { GetUserTypesRequest } from "../../../../../../../../../repository/UserManagement/usertype_pb"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { SessionExpiredDialog } from "../../../../../../../../common/SessionExpiredDialog/SessionExpiredDialog"
import React from "react"
import { bool } from "yup"
import { updateItem, dismissMessage, removeItem, reset, resetItem, getItem } from "./DataRestrictionDetailsPageSlice"
import { DeleteRoleRequest } from "../../../../../../../../../repository/UserManagement/role_pb"
import { DeleteGroupRequest, GetGroupsRequest } from "../../../../../../../../../repository/UserManagement/group_pb"
import { abort, getgroups } from "process"
import { Popup } from "../../../../../../../../common/Popup/Popup"
import { GroupsForm } from "../../../../../../../../forms/Management/Groups/GroupsForm"
import { FormType } from "../../../../../../../../forms/FormProps"
import { TextView } from "../../../../../../../../common/DataView/TextView"
import { ProfileView } from "../../../../../../../../common/DataView/ProfileView"
import { DeleteGroupMembershipRequest, GetGroupMembershipRequest } from "../../../../../../../../../repository/UserManagement/groupmembership_pb"
import { LinkView } from "../../../../../../../../common/DataView/LinkView"
import { DeleteDataRestrictionRequest, GetDataRestrictionRequest } from "../../../../../../../../../repository/UserManagement/datarestriction_pb"
import { DataRestrictionsForm } from "../../../../../../../../forms/Management/DataRestriactions/DataRestriactionsForm"
import { useReactToPrint } from "react-to-print"

const shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
};


let req: GetDataRestrictionRequest;

let org: number = -1;

let getGroupsPromise: any;
let actionPromise: any;


const key = "management/dataRestrection/details"
export const DataRestrictionDetailsPage: React.FunctionComponent = () => {

    const dispatch = useAppDispatch()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let { id } = useParams();
    const { hash } = useLocation();
    const [selectedKey, setSelectedKey] = useState("0");

    const state: {
        isChangeStateLoading: boolean,
        message: ApiMessage | undefined,
        appTheme: string, isDarkModeEnabled: boolean,
        isLoading: boolean,
        item: any
    } = useAppSelector((state) => {
        return {
            isChangeStateLoading: state.managersDataRestrictionDetailsPage.isChangeStateLoading,
            message: state.managersDataRestrictionDetailsPage.message,
            appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled,
            isLoading: state.managersDataRestrictionDetailsPage.isLoading,
            item: state.managersDataRestrictionDetailsPage.item,

        }
    })
    const calloutTargetId = useId('callout-target');
    const labelId = useId('callout-label');
    const deleteActionConfirmationcalloutTargetId = useId('delete-action-callout-target');
    const ActionConfirmationLabelId = useId('action-callout-label');
    const shareCalloutLabelId = useId('share-callout-label');
    const shareTargetId = useId('share-callout-target');

    const [isActionConfirmationCalloutVisible, { toggle: toggleisActionConfirmationCalloutVisible }] = useBoolean(false);
    const [isShareCalloutVisible, { toggle: toggleisShareCalloutVisible }] = useBoolean(false);

    const [currentAction, setCurrenctAction] = useState(0)

    const ref = useRef<HTMLDivElement>(null);
        const reactToPrintContent = () => {
        return printComponent(ref.current?.cloneNode(true), true);
    };

    const handlePrint = useReactToPrint({});

    const getActionId = (action: number): string => {
        if (action == 1)
            return deleteActionConfirmationcalloutTargetId;
        else {
            return ""
        }
    }


    useEffect(() => {
        // console.log("32")
        req = new GetDataRestrictionRequest();
        var l = searchParams.get('org');
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
            }
        }
        const page = getPage(key)

        dispatch(setTitle(t(normalizeKey(page?.title))));
        dispatch(setPage(page));

        if (id) {
            let i = Number(id);
            if (Number.isNaN(id)) {
                navigate(-1)
            } else {
                req.setId(i)
                getGroupsPromise = dispatch(getItem({ body: req, headers: getHeaders() }))
            }

        } else {
            navigate(-1)
        }


        return () => { //clean up
            getGroupsPromise?.abort();
            actionPromise?.abort();
            dispatch(reset());
        }
    }, [])



    const _selectionItems: ICommandBarItemProps[] = [
        {
            key: 'back',
            text: t('back'),
            title: t('back'),
            iconProps: { iconName: 'back' },
            disabled: state.isLoading,
            onClick: () => {
                navigate(-1)
            }
        },
        {
            key: 'refresh',
            text: t('refresh'),
            title: t('refresh'),
            iconProps: { iconName: 'refresh' },
            disabled: state.isLoading,
            onClick: () => {
                dispatch(resetItem())
                getGroupsPromise = dispatch(getItem({ body: req, headers: getHeaders() }))
            }
        },

        {
            key: 'edit',
            text: t("edit"),
            title: t('edit'),
            iconProps: { iconName: 'EditSolid12' },
            disabled: !state.item?.privilegeDataType,
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(101)
                }
            }

        },

        {
            key: 'delete',
            text: t("delete"),
            title: t('delete'),
            iconProps: { id: deleteActionConfirmationcalloutTargetId, iconName: "Delete", styles: { root: { fontWeight: "bold" } } },
            commandBarButtonAs: (e) => {
                return <CommandBarButton {...(e as IButtonProps)} iconProps={state.isChangeStateLoading && currentAction == 1 ? undefined : e.iconProps} text={state.isChangeStateLoading && currentAction == 1 ? undefined : e.text}  >
                    <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isChangeStateLoading && currentAction == 1 ? "block" : "none") } }} />
                </CommandBarButton>;
            },
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    setCurrenctAction(1)
                    toggleisActionConfirmationCalloutVisible()
                }
            }
        },
        {
            key: 'logs',
            text: t("logs"),
            iconProps: { iconName: "PageList", styles: { root: { fontWeight: "bold" } } },
            title: t("logs"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    navigate("/logs?resourceId=" + state.item?.id + ((org == -1) ? "" : "&org=" + org));
                }
            }
        },
        {
            key: 'share',
            text: t("share"),
            title: t('share'),
            iconProps: { id: shareTargetId, iconName: 'Share', styles: { root: { fontWeight: "bold" } } },
            onClick: () => {
                toggleisShareCalloutVisible()
            },

        },
        {
            key: 'print',
            text: t("print"),
            iconProps: { iconName: "Print", styles: { root: { fontWeight: "bold" } } },
            title: t("print"),
            onClick: () => {
                if (!state.isChangeStateLoading) {
                    handlePrint(reactToPrintContent);
                }
            }
        },
    ];



    return (
        <Stack >
            {state.message != undefined ? (state.message.data != 401) ? <Message
                body={state.message.body}
                title={state.message.title}
                data={state.message.data}
                onDismiss={() => { dispatch(dismissMessage()) }}
                type={state.message.type}
            /> :
                <SessionExpiredDialog />
                : null
            }



            <Popup isOpen={(currentAction == 101)} title={t("editRestriaction")} onDismiss={() => { setCurrenctAction(0) }} >

                <DataRestrictionsForm childrenGap={10} maxWidth={280} type={FormType.EDIT} renderObject={{ ...state.item, privilegeData: { dataType: state.item?.privilegeDataType } }} onSuccess={(e) => {
                    setCurrenctAction(0)
                    dispatch(updateItem(e))
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>
            {isShareCalloutVisible ? (
                <Callout
                    ariaLabelledBy={shareCalloutLabelId}
                    target={`#${shareTargetId}`}
                    onDismiss={toggleisShareCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <ShareBox onDismiss={toggleisShareCalloutVisible} title={t("shareDataRestrection")} value={`https://${window.location.host}/management/data-restrictions/${state.item?.id}` + ((org == -1) ? "" : "?org=" + org)}></ShareBox>
                </Callout>
            ) : null}

            {isActionConfirmationCalloutVisible ? (
                <Callout
                    ariaLabelledBy={ActionConfirmationLabelId}
                    target={`#${getActionId(currentAction)}`}
                    onDismiss={toggleisActionConfirmationCalloutVisible}
                    directionalHint={DirectionalHint.bottomLeftEdge}
                    beakWidth={20}
                    styles={{
                        root: {
                            width: 370,
                        }
                    }}
                >
                    <Stack tokens={{ padding: '20px 24px ' }}>
                        <Text block variant="xLarge" styles={{ root: { marginBottom: 12 } }}>
                            {(currentAction == 1 ? t("daleteRestriction") : "")}
                        </Text>
                        <Text block variant="small">
                            {(currentAction == 1 ? t("daleteRestrictionDesc") : "")}

                        </Text>
                        {/* This FocusZone allows the user to go between buttons with the arrow keys.
              It's not related to or required for FocusTrapCallout's built-in focus trapping. */}
                        <FocusZone handleTabKey={FocusZoneTabbableElements.all} isCircularNavigation>
                            <Stack reversed tokens={{ childrenGap: 8, padding: "20px 0px 0px 0px" }} horizontal>
                                <DefaultButton autoFocus onClick={toggleisActionConfirmationCalloutVisible}>{t("cancel")}</DefaultButton>

                                <PrimaryButton onClick={() => {
                                    toggleisActionConfirmationCalloutVisible()
                                    if (state.item) {
                                        if (currentAction == 1) {
                                            let req = new DeleteDataRestrictionRequest();
                                            req.setId(state.item?.id)
                                            if ((org != -1)) {
                                            }

                                            actionPromise?.abort();
                                            actionPromise = dispatch(removeItem({ body: req, headers: getHeaders() }))
                                            actionPromise.unwrap().then((e: any) => {
                                                navigate(-1)
                                            })
                                        }
                                    }
                                }} text={(currentAction == 1 ? t("delete") : "")}  >

                                </PrimaryButton>
                            </Stack>
                        </FocusZone>
                    </Stack>
                </Callout>
            ) : null}


            {state.isLoading ? <ProgressIndicator /> :

                !state.item ? null :
                    <div ref={ref}>
                        <CommandBar
                            items={_selectionItems}
                        />
                        <Stack tokens={{ childrenGap: 10, padding: "0px 36% 10px 3%" }}>

                            <Stack horizontal tokens={{ childrenGap: 10 }}>

                                <TextView label={t("id")} value={state.item?.id} />


                                <TextView label={t("createdDate")} value={state.item?.createdDate} />

                                {state.item?.addedBy ? <ProfileView label={t("addedBy")} value={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    url={"/management/users/" + state.item?.addedById + ((org == -1) ? "" : "?org=" + org)}
                                    text={state.item?.addedBy == "" ? state.item?.addedById : state.item?.addedBy}
                                    size={PersonaSize.size40} />

                                    : undefined}

                            </Stack>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>


                                <LinkView label={t("group")} value={state.item?.groupName}
                                    url={"/management/groups/" + state.item?.groupId + ((org == -1) ? "" : "?org=" + org)} />

                                <LinkView label={t("privilegeData")} value={state.item?.privilegeDataName}
                                    url={"/management/privilege-data/" + state.item?.privilegeDataId + ((org == -1) ? "" : "?org=" + org)} />


                            </Stack>
                            {state.item?.allowedData?.enum ?
                                <TextView label={t("enumValues")} value={state.item?.allowedData?.enum?.map((a: any) => {
                                    return "{" + a + "} ";
                                })} />
                                : undefined}
                            {state.item?.allowedData?.blocked ?
                                <TextView label={t("blockedValues")} value={state.item?.allowedData?.blocked?.map((a: any) => {
                                    return "{" + a + "} ";
                                })} />
                                : undefined}
                            {state.item?.allowedData?.range ?

                                <TextView label={t("rangeValues")} value={state.item?.allowedData?.range?.map((a: any) => {
                                    return " ( " + t("from") + ": " + a?.from + "  " + t("to") + ": " + a?.to + " )";
                                })} />
                                : undefined}
                            {state.item?.allowedData?.regex ? <TextView label={t("regexValues")} value={state.item?.allowedData?.regex} />
                                : undefined}

                        </Stack>
                    </div>


            }


        </Stack>



    );
}




